import { SourceDataFindingStatus, SourceDataFindingType } from "@/api/dtos";

const mapping: Record<SourceDataFindingStatus, string> = {
    [SourceDataFindingStatus.Pending]: 'Pending',
    [SourceDataFindingStatus.Resolved]: 'Resolved',
    [SourceDataFindingStatus.NotApplicable]: 'Not Applicable'
};

const sourceDataFindingStatusToText = (status?: SourceDataFindingStatus) => {
    if (!status) {
        return 'Unknown'
    }

    return mapping[status];
}

export default sourceDataFindingStatusToText;